import React, { useRef } from 'react'
import clsx from 'clsx'
import { AuroraBackgroundProps } from './aurora/seeds'
import { AuroraBaseGrid, AuroraGlowGrid } from './aurora/AuroraGrid'
import { AuroraBlobs } from './aurora/AuroraBlobs'
import { GridPulseCanvas } from './aurora/GridPulseCanvas'
import './aurora/aurora.css'

export type { AuroraBackgroundProps } from './aurora/seeds'

export const AuroraBackground: React.FC<AuroraBackgroundProps> = ({ className = '', seed }) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const parallaxRef = useRef<HTMLDivElement>(null)

  return (
    <div
      ref={containerRef}
      aria-hidden="true"
      className={clsx(
        'absolute -top-20 md:-top-32 -bottom-48 md:-bottom-80 xl:-bottom-[32rem] left-1/2 -translate-x-1/2 w-screen pointer-events-none z-0 select-none overflow-hidden',
        className
      )}
      style={{
        maskImage:
          'radial-gradient(ellipse 115% 70% at 50% 20%, #000 20%, rgba(0, 0, 0, 0.8) 40%, rgba(0, 0, 0, 0.3) 55%, transparent 70%)',
        WebkitMaskImage:
          'radial-gradient(ellipse 115% 70% at 50% 20%, #000 20%, rgba(0, 0, 0, 0.8) 40%, rgba(0, 0, 0, 0.3) 55%, transparent 70%)',
      }}
    >
      <div
        ref={parallaxRef}
        className="relative w-full h-full will-change-transform opacity-[0.28] dark:opacity-[0.30] transition-opacity duration-700"
      >
        {/* Base ambient grid under blobs */}
        <AuroraBaseGrid />

        {/* Aurora blobs layer with blur filter */}
        <AuroraBlobs seed={seed} containerRef={containerRef} parallaxRef={parallaxRef} />

        {/* Revealed glowing grid over blobs */}
        <AuroraGlowGrid />
      </div>

      {/* Interactive glowing signals along grid */}
      <GridPulseCanvas />
    </div>
  )
}

export default AuroraBackground
